import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  breadcrumbContainer: {
    margin: "75px auto -70px auto",
    maxWidth: "1350px",
    display: "flex",
  },
  customLink: {
    textDecoration: "none",
    color: theme.palette.text.tertiary,
    "&:hover": {
      color: theme.palette.text.tertiary,
      textDecoration: "none",
    },
  },
  fontLink: {
    fontFamily: "MontserratMedium",
    fontWeight: "500",
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "26px",
  },
  pageContainer: {
    minHeight: "100vh",
    color: "#ffffff",
    position: "relative",
    overflowX: "hidden",
    paddingBottom: theme.spacing(8),
    marginTop: theme.spacing(8),
  },

  bgGlowTop: {
    position: "fixed",
    top: "-10%",
    right: "-5%",
    width: 500,
    height: 500,
    backgroundColor: "rgba(0, 108, 72, 0.2)",
    borderRadius: "50%",
    filter: "blur(120px)",
    pointerEvents: "none",
    zIndex: 0,
  },

  bgGlowBottom: {
    position: "fixed",
    bottom: "-10%",
    left: "-5%",
    width: 400,
    height: 400,
    backgroundColor: "rgba(75, 86, 173, 0.1)",
    borderRadius: "50%",
    filter: "blur(100px)",
    pointerEvents: "none",
    zIndex: 0,
  },

  mainContent: {
    position: "relative",
    zIndex: 1,
    paddingTop: theme.spacing(6),
  },

  contentGrid: {
    marginTop: theme.spacing(8),
  },
}));

export default useStyles;
